import { Button } from "antd";
import { useGetPayoutQuery } from "api/TenantSlug/Payout/hooks";
import { TransactionReportEditForm } from "components/Forms/TransactionReportEditForm/TransactionReportEditForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle";
import { useDrawer } from "hooks/useDrawer";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models";

interface TransactionReportEditProps {
    onSubmit: () => void;
    payoutId: string;
}

export const TransactionReportEditDrawer: FC<TransactionReportEditProps> = ({ onSubmit, payoutId }) => {
    const { t: tDrawer } = usePaldockTranslation("drawers.transaction-report-edit");
    const { t } = usePaldockTranslation("common");
    const drawerId = DrawerId.TransactionReportEdit;
    const drawerUtils = useDrawer();

    // Only fetch and render when drawer is active
    const isActive = drawerUtils.isDrawerActive(drawerId);

    const getPayoutQuery = useGetPayoutQuery(
        payoutId,
        {
            filter: {
                include:
                    "conversionState,conversionState.owner,conversionState.advertiser,conversionState.offer,conversionState.cascade,children,children.commission,currency,commission",
            },
        },
        { enabled: isActive }
    );

    // Don't render anything if drawer is not active
    if (!isActive) {
        return null;
    }

    const payout = getPayoutQuery.data?.payout;

    if (!payout) {
        return null;
    }

    const handleSuccess = () => {
        // dirty hot fix - why not working without delay?? TODO refactor whole table refetch logic bcs its shit due to antd..
        setTimeout(() => {
            onSubmit?.();
            getPayoutQuery.refetch();
        }, 100);
    };

    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={tDrawer("title")} />}
            searchParamsToClean={[`${drawerId}-id`]}
            extraButtons={
                <Button size={"large"} type={"primary"} htmlType="submit" form={FormId.TransactionReportEditForm}>
                    {t("save")}
                </Button>
            }
        >
            <TransactionReportEditForm
                payoutData={payout}
                formId={FormId.TransactionReportEditForm}
                onSuccess={handleSuccess}
            />
        </Drawer>
    );
};
